module.exports = __webpack_public_path__ + "img/zhenliao.bd444b65.png";